// extracted by mini-css-extract-plugin
export default {"root":"dataTable_root__I+Xz9","table":"dataTable_table__OXeUw","colorInherit":"dataTable_colorInherit__Q-HYv"};